import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "exts" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_FileIcon = _resolveComponent("FileIcon")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    class: "download-doc",
    "show-arrow": false,
    trigger: "hover",
    placement: "bottom-start",
    teleported: false,
    offset: 1,
    onShow: _cache[0] || (_cache[0] = $event => ($data.visible = true)),
    onHide: _cache[1] || (_cache[1] = $event => ($data.visible = false))
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", {
        class: "icon-wrapper pointer",
        disabled: $props.disabled
      }, [
        _createVNode(_component_Icon, {
          class: "icon",
          hover: $data.visible,
          hoverable: "",
          icon: "download",
          "stroke-width": "1",
          stroke: $props.color,
          width: $props.size,
          height: $props.size
        }, null, 8 /* PROPS */, ["hover", "stroke", "width", "height"])
      ], 8 /* PROPS */, _hoisted_1)
    ]),
    default: _withCtx(({ hide }) => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.exts, (ext) => {
          return (_openBlock(), _createElementBlock("div", {
            key: ext,
            class: "ext pointer",
            onClick: $event => ($options.save(ext, hide))
          }, [
            _createVNode(_component_FileIcon, {
              class: "icon",
              ext: ext,
              "font-size": "0.6rem",
              width: "1.9",
              height: "2.2rem"
            }, null, 8 /* PROPS */, ["ext"]),
            _createElementVNode("div", _hoisted_4, "Download " + _toDisplayString(ext.toUpperCase()), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_3))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }))
}